import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export function useOpenLeadReportCsv({ api }: { api: ApiType }) {
  return useMutation({
    mutationFn: async ({
      leadSourceList,
      leadStatusList,
    }: {
      leadSourceList?: number[];
      leadStatusList: string[];
    }) => {
      return await api.leadApi.openReportCsv({
        leadSourceList,
        leadStatusList,
      });
    },
  });
}
